import Icon from 'vue-awesome/components/Icon'

Icon.register({
  invert_colors_off_two_tone: {
    paths: [
      {
        opacity: '.3',
        d: 'M6 13.59c0 1.6.62 3.1 1.76 4.24A5.928 5.928 0 0012 19.59v-4.8L7.21 10A5.907 5.907 0 006 13.59z'
      },
      {
        d: 'M12 5.1v4.05l7.4 7.4c1.15-2.88.59-6.28-1.75-8.61L12 2.27 8.56 5.71l1.41 1.41L12 5.1zm-7.6-.73L2.99 5.78l2.78 2.78a8.003 8.003 0 00.57 10.68A7.98 7.98 0 0012 21.58c1.78 0 3.56-.59 5.02-1.77l2.7 2.7 1.41-1.41L4.4 4.37zM12 19.59c-1.6 0-3.11-.62-4.24-1.76A5.945 5.945 0 016 13.59c0-1.32.43-2.56 1.21-3.59L12 14.79v4.8z'
      },
      {
        opacity: '.3',
        d: 'M12 9.15V5.1L9.97 7.12z'
      }
    ],
    width: '24',
    height: '24'
  }
})
